// 알림톡 발송 유틸리티 (백엔드 서버를 통한 프록시 방식)
const BACKEND_CONFIG = {
  baseUrl: process.env.REACT_APP_BACKEND_URL || 'https://member.koima.or.kr', // 운영환경 백엔드 서버 주소
  alimTalkEndpoint: '/api/alimtalk/send'
};

export const sendAlimTalk = async (memberData) => {
  try {
    const { companyName, ceoName, phone } = memberData;
    
    console.log('백엔드를 통한 알림톡 발송 시작:', { companyName, ceoName, phone });
    
    // 백엔드 서버로 요청
    const response = await fetch(`${BACKEND_CONFIG.baseUrl}${BACKEND_CONFIG.alimTalkEndpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        companyName,
        ceoName,
        phone
      })
    });

    if (response.ok) {
      const result = await response.json();
      console.log('알림톡 발송 성공:', result);
      return { success: true, result };
    } else {
      const errorData = await response.json();
      console.error('알림톡 발송 실패:', response.status, errorData);
      return { success: false, error: errorData.error || `HTTP ${response.status}` };
    }
  } catch (error) {
    console.error('알림톡 발송 중 오류:', error);
    return { success: false, error: error.message };
  }
};

// 템플릿 변수 치환 함수
export const replaceTemplateVariables = (template, variables) => {
  let result = template;
  Object.entries(variables).forEach(([key, value]) => {
    result = result.replace(`#{${key}}`, value);
  });
  return result;
};